import { useEffect, useState } from 'react';
import type { ReferencedObjectPickerOption as ObjectPickerOption } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/picker-options.tsx';
import { toCmdbObjectId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type { ReferencedObjectSearchResponse } from '../common/types.tsx';

export const mapOptionsFromData = (
	response?: ReferencedObjectSearchResponse,
): ObjectPickerOption[] | undefined =>
	response?.map<ObjectPickerOption>(({ id, objectKey, label, avatar }) => ({
		id: toCmdbObjectId(id),
		label,
		value: objectKey,
		objectKey,
		avatar,
	}));

export const useObjectPickerState = (searchData?: ReferencedObjectSearchResponse) => {
	const [defaultOptions, setDefaultOptions] = useState<ObjectPickerOption[] | undefined>();

	useEffect(() => {
		if (defaultOptions === undefined) {
			setDefaultOptions(() => mapOptionsFromData(searchData));
		}
	}, [defaultOptions, searchData]);

	return [defaultOptions, setDefaultOptions] as const;
};
